<template>
  <NuxtLayout>
    <ClientOnly>
      <SmoothScroll />
    </ClientOnly>
    <NuxtPage />
  </NuxtLayout>
  
  <!-- 全局 Loading -->
  <PokerLoading :is-loading="globalLoading" @ready="handleLoadingAnimationReady" />
</template>

<script setup lang="ts">
const globalLoading = ref(true);
const isApplicationReady = ref(false);
const isLoadingAnimationReady = ref(false);
const isInitialLoadingComplete = useState('initial-loading-complete', () => false);

const finishLoading = () => {
  globalLoading.value = false;
  isInitialLoadingComplete.value = true;
};

const closeLoadingWhenReady = () => {
  if (!isApplicationReady.value || !isLoadingAnimationReady.value || !globalLoading.value) return;

  finishLoading();
};

const handleLoadingAnimationReady = () => {
  isLoadingAnimationReady.value = true;
  closeLoadingWhenReady();
};

watch(globalLoading, (isLoading, wasLoading) => {
  if (isLoading && !wasLoading) {
    isLoadingAnimationReady.value = false;
  }
});

// Nuxt 完成掛載、且 Loading 動畫可用後立即移除遮罩。
onMounted(async () => {
  await nextTick();
  isApplicationReady.value = true;
  closeLoadingWhenReady();
});
</script>
